import React, { useEffect } from 'react'

import moment from 'moment'

import { DatePicker, Tooltip } from 'antd'

type QuoteExpirationProps = {
  quoteScheduledToExpireAt?: string
  defaultQuoteValidForDays: number
  onChange: (date: Nullable<string>) => void
  onSetDefaultExpiration: (date: Nullable<string>) => void
}

// Keep this component without store relation because it's used by the public vendors and private vendors
export const QuoteExpiration = ({
  quoteScheduledToExpireAt,
  defaultQuoteValidForDays,
  onChange,
  onSetDefaultExpiration,
}: QuoteExpirationProps) => {
  useEffect(() => {
    if (!quoteScheduledToExpireAt && !!defaultQuoteValidForDays) {
      const defaultExpirationDate = moment().add(defaultQuoteValidForDays, 'days')
      onSetDefaultExpiration(defaultExpirationDate?.utc()?.startOf('day')?.add(12, 'hours')?.toISOString())
    }
  }, [quoteScheduledToExpireAt, defaultQuoteValidForDays])

  return (
    <Tooltip title="Quote Expiration">
      <DatePicker
        placeholder="Quote Expiration"
        style={{ minWidth: 130 }}
        value={quoteScheduledToExpireAt ? moment(quoteScheduledToExpireAt) : undefined}
        onChange={(date) => {
          const expirationDate = date?.utc()?.startOf('day')?.add(12, 'hours')?.toISOString() || null
          onChange(expirationDate)
        }}
        allowClear
      />
    </Tooltip>
  )
}
